import { Component, Input } from "@angular/core";
import { Colors, Sizes, State, Width, IconPosition } from "../types/buttons.types";

@Component({
  selector: "ds-button",
  templateUrl: "./ds-button.component.html",
  styleUrls: ["./ds-button.component.scss"],
})
export class DsButtonComponent {
  @Input() label!: string;
  @Input() color: Colors = "primary";
  @Input() size: Sizes = "sm";
  @Input() disabled: boolean = false;
  @Input() icon: string = "";
  @Input() state: State = "default";
  @Input() selected: boolean = false;
  @Input() width: Width = "content";
  @Input() fixedWidth: string = "200px";
  @Input() iconPosition: IconPosition = IconPosition.START;
  @Input() loading: boolean = false;
  @Input() loadingText: string = "Cargando";
  @Input() dsIcon: string = "";
  @Input() iconColor: string = "";

  constructor() {}
}
